import { sample } from 'effector';

import { getCurrentEmployeeFx, getFeaturesFx } from 'shared/api';
import { $isAuthenticated } from 'shared/auth';
import { $currentUser } from 'entities/currentUser';
import { $features } from 'entities/featureToggling';

sample({
  source: [$isAuthenticated, $currentUser],
  filter: ([isAuthenticated, currentUser]) => Boolean(!currentUser && isAuthenticated),
  fn: () => ({}),
  target: getCurrentEmployeeFx,
});

sample({
  source: {
    isAuthenticated: $isAuthenticated,
    features: $features,
  },
  filter: ({ isAuthenticated, features }) => isAuthenticated && !features,
  fn: () => ({}),
  target: getFeaturesFx,
});
